export const findErrorInMojTakatakLink = link => {
	// add https in the end if necessary
	for (let newHref of link) {
		const hasHttpOrHttps = newHref.match(/^https?:\/\//);
		if (!hasHttpOrHttps) {
			newHref = `https://${newHref}`;
		}

		try {
			let url = new URL(newHref);

			if (
				!url.hostname.endsWith("mojapp.in") &&
				!(url.hostname.endsWith("www.mxtakatak.com") || url.hostname.endsWith("share.mxtakatak.com"))
			) {
				return `${newHref} is not moj/takatak link`;
			}
			// if (!url.hostname.endsWith("www.mxtakatak.com")) {
			// 	return `${newHref} is not moj/ link`;
			// }
		} catch (error) {
			return `${newHref} is not a valid url`;
		}
	}
	return null;
};
